/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".day-month-picker[_ngcontent-%COMP%]{padding:0;border:0;display:inline-flex}"];
export { styles as styles };
